// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3KOCn","inputDescription":"styles_inputDescription__3dKk2"};